import { ArrowRightIcon, XIcon } from '@heroicons/react/solid';
import {
  FirstOrderContainer,
  SecondOrderContainer,
  ThirdOrderContainer,
} from 'components/products/journey';
import { JourneyContext } from 'components/products/journey/JourneyContext';
import { LoadingModal } from 'components/products/journey/LoadingModal';
import { CardBackground, LoadingSpinner } from 'components/ui';
import { useContext, useEffect } from 'react';
import { useParseURLQueryParams } from 'utils';
import { InstructionsGraphics } from './InstructionsGraphics';

export const JourneyGrid = () => {
  const { query } = useParseURLQueryParams();

  const {
    firstProduct,
    secondProduct,
    handleClearSelection,
    productList,
    journey,
    journeyLoading,
    isJourneyError,
    secondOrders,
    thirdOrders,
  } = useContext(JourneyContext);

  // Clear selection on change date
  useEffect(() => {
    if (firstProduct && query.start_date && query.end_date) {
      handleClearSelection();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query.start_date, query.end_date]);

  if (!!!productList?.length) {
    return (
      <div className="mt-16">
        <CardBackground>
          <div className="p-11 h-segments-800px">
            <div className="grid h-full place-items-center">
              <LoadingSpinner className="w-16 h-16 text-segments-accent-color-orange" />
            </div>
          </div>
        </CardBackground>
      </div>
    );
  }

  return (
    <>
      <div className="relative flex">
        <div className="grid items-center flex-1 grid-cols-3 px-6 font-bold text-segments-13px">
          <p>
            1st Order{' '}
            <span className="font-normal text-black text-opacity-30">
              {productList?.length && `(${productList.length} products found)`}
            </span>
          </p>
          <div className="flex items-center -ml-4 space-x-4">
            <ArrowRightIcon className="w-5 h-5" />
            <p>
              2nd Order{' '}
              <span className="font-normal text-black text-opacity-30">
                {journey?.id === firstProduct?.id &&
                  secondOrders?.length &&
                  `(${secondOrders.length} products found)`}
              </span>
            </p>
          </div>
          <div className="flex items-center space-x-4 -ml-0.5">
            <ArrowRightIcon className="w-5 h-5" />
            <p>
              3rd Order{' '}
              <span className="font-normal text-black text-opacity-30">
                {secondProduct &&
                  thirdOrders?.length &&
                  `(${thirdOrders?.length} products found)`}
              </span>
            </p>
          </div>
        </div>
        <div>
          {firstProduct && (
            <button
              className="absolute flex items-center bottom-0.5 right-3 focus:outline-none"
              onClick={handleClearSelection}
            >
              <XIcon className="w-6 h-6" />
            </button>
          )}
        </div>
      </div>
      <div className="mt-2 overflow-hidden">
        <CardBackground>
          <div className="grid grid-cols-3 h-segments-800px">
            <LoadingModal loading={journeyLoading} />
            <div className="border-r">
              <FirstOrderContainer data={productList} />
            </div>
            {!!!firstProduct ? (
              <div className="flex flex-col items-center justify-center col-span-2 space-y-5 text-black text-opacity-30">
                <InstructionsGraphics />
                Select 1st product to analyze
              </div>
            ) : isJourneyError ? (
              <div className="grid col-span-2 text-black place-items-center text-opacity-30">
                Failed to perform the task. Please try again or contact our team
                for support
              </div>
            ) : (
              <>
                <SecondOrderContainer
                  data={secondOrders}
                  isFetching={journeyLoading}
                />

                <ThirdOrderContainer data={thirdOrders} />
              </>
            )}
          </div>
        </CardBackground>
      </div>
    </>
  );
};
